import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { withFieldGroup } from '@/components/Form';
import { cn } from '@/lib/utils';

import RuleBuilderAttribute from './RuleBuilderAttribute';
import RuleBuilderRemoveButton from './RuleBuilderRemoveButton';
import type {
  AndConditionPath,
  AttributePath,
  ConditionFieldValues,
  RuleEntityType,
} from './types';
import { useAudienceRuleForm } from './types';

type RuleBuilderConditionProps = {
  basePath: AndConditionPath;
  ruleEntity: RuleEntityType;
  disabled?: boolean;
  onConditionRemove: () => void;
};

const buildAttributePath = (basePath: AndConditionPath, attrIndex: number): AttributePath =>
  `${basePath}.attributes[${attrIndex}]`;

const RuleBuilderCondition = withFieldGroup({
  defaultValues: {
    attributes: [],
  } as ConditionFieldValues,
  props: {} as RuleBuilderConditionProps,
  render: function RuleBuilderConditionRender({
    group,
    basePath,
    ruleEntity,
    disabled = false,
    onConditionRemove,
  }) {
    const form = useAudienceRuleForm();

    return (
      <div
        className={cn(
          'relative border-l-3 border-gray-500 pl-4',
          'flex w-full items-start justify-start gap-6',
        )}
      >
        <group.Field name="attributes" mode="array">
          {(arrayField) =>
            arrayField.state.value.map((attrValue, attrIndex) => {
              const attribute = ruleEntity.attributes.find((a) => a.id === attrValue.field);
              if (!attribute) return null;

              return (
                <RuleBuilderAttribute
                  key={attrIndex}
                  form={form}
                  fields={buildAttributePath(basePath, attrIndex)}
                  attribute={attribute}
                  disabled={disabled}
                />
              );
            })
          }
        </group.Field>
        <RuleBuilderRemoveButton
          title={<Trans>Remove rule</Trans>}
          aria-label={t`Remove rule`}
          disabled={disabled}
          onClick={onConditionRemove}
        />
      </div>
    );
  },
});

export default RuleBuilderCondition;
